var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{ref:"refmap",attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_vm._l((_vm.markers),function(marker){return _c('l-marker',{key:marker.id,attrs:{"lat-lng":marker.coordinates}},[_c('l-popup',[_c('span',{domProps:{"innerHTML":_vm._s(marker.popup)}})])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }